import React, {Component} from 'react';
import TopLevel from './TopLevel';
import SideNavInternal from 'go/components/dynamic/layout/SideNavInternal';
import _ from 'lodash';
import {isSubApplicationConfig} from 'go/components/dynamic/modules/grantLandingPage/utils';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {connect} from 'react-redux';
import {HOME} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';

export class GrantSummaryNavItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config: null,
    };
  }

  componentDidUpdate() {
    let hash = this.props.hash;
    if (hash) {
      hash = hash.replace(/[&\/\\#,+()$~%.'":*?<>{}0-9]/g, ' ');
      // On Application, when clicking children items under Grant request details
      // the hash used for the page title looks like #item-1-children-uuid-string
      // Here if the hash contains 'children', we'll assign the page title in
      // RequestDetailsSideNav.js child menu item in the <Menu.Item onClick
      if (hash.indexOf('children') === -1) {
        document.title = `${HOME} - ${hash}`;
      }
    }
  }

  setActivePage(configName) {
    this.props.loadPageWithConfig(configName);
  }

  render() {
    const {baseClass, isActive, config} = this.props;
    const {configType} = config;

    const reportName = isSubApplicationConfig(configType)
      ? 'Subgrant summary'
      : 'Grant summary';
    const activePage = isSubApplicationConfig(configType)
      ? 'subGrantSummary'
      : 'grantSummary';

    return (
      <React.Fragment>
        <TopLevel
          name={reportName}
          baseClass={baseClass}
          handleClick={() => this.setActivePage(activePage)}
          active={isActive}
          isExpandable={false}
        />
        {isActive && config && (
          <React.Fragment>
            <SideNavInternal
              navToSpecificLocation={() => {
                /* this is the key to making the sidenav active state work
                          don't use until figuring out how to incorporate VisibilitySensor into this
                        */
              }}
              location={this.props.location}
              title={'Grant Summary Navigation'}
              startingIndentLevel={1}
              {...config.payload}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    hash: state.router.location.hash,
  };
};

export default connect(mapStateToProps, null)(connectDynamic(GrantSummaryNavItem));
